export const STICKY_HEADER_TOP = 95;
export const HEADER_HIDE_ZONE = 150;
